/**
 * Fills in each card reference in a normalized game payload with its catalog details. Face-down cards have no id
 * and stay as they are. Fields on the reference (order, pivot_id, attachments) win over catalog fields.
 */
export function withCardDetails(entity, cardsById) {
  if (Array.isArray(entity)) {
    return entity.map(item => withCardDetails(item, cardsById));
  }

  if (!entity || typeof entity !== 'object') {
    return entity;
  }

  const filled = {};

  for (const key of Object.keys(entity)) {
    if (key === 'card') {
      filled[key] = withDetails(entity[key], cardsById);
    } else if (key === 'cards' && Array.isArray(entity[key])) {
      filled[key] = entity[key].map(card => withDetails(card, cardsById));
    } else {
      filled[key] = withCardDetails(entity[key], cardsById);
    }
  }

  return filled;
}

function withDetails(card, cardsById) {
  const reference = withCardDetails(card, cardsById);
  const details = reference && cardsById.get(reference.id);

  return details ? { ...details.toJS(), ...reference } : reference;
}
